<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Open Space Technology</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="coverpage">
<img alt="cover" src="images/cover.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// CoverPage.vue?4951c1ee